import { handleRequest } from "../utilities/requestHandler";

export const requestListHistory = (req_body) =>
    handleRequest("post", "/request_list/history", req_body);